<!-- MAIN PAGE WRAPPER -->
<div class="flxClmn" style="position: relative; height: 100vh; min-height: 0; overflow: hidden;">
	<span>
		Visualization of the connections between the resources related to your users: channels, chats, and meetings. Gain insights into networks and data exposure patterns.
	</span>

	<!-- CONTROLS -->
	<div class="page-inner-content-holder dashboard-page bs-enabled flxClmn"
		 style="padding-top: 0; flex: 0 0 auto; min-height: 0; background: transparent;">

		<!-- Row 1 : period selector + user filter -->
		<div class="flxRow-between align-items-center gap-3 animated fadeIn"
			 style="position: relative; z-index: 45; margin: 16px 0 10px;">

			<div class="period-buttons-group bs-enabled flex-row gap-2">
				<button class="period-button bs-btn h-100"
						*ngFor="let item of dashboardPeriod | keyvalue: gs.returnZero;"
						[ngClass]="{
							'chosen' : period === item.value,
							'd-none' : item.value.display === dic.CONSTANTS.trendsPeriod.range.display
						}"
						[style.background]="period === item.value ? 'rgba(77,138,240,0.2)' : 'rgba(255,255,255,0.05)'"
						[style.color]="period === item.value ? '#4d8af0' : '#8892a4'"
						[style.border]="period === item.value ? '1px solid rgba(77,138,240,0.45)' : '1px solid rgba(255,255,255,0.1)'"
						(click)="changePeriod(item.value);">
					{{item.value.display}}
				</button>
			</div>

			<!-- Filter Users — badge shows active filter count -->
			<div class="flxRow align-items-center gap-2" style="position: relative;">
				<btn-c endIcon="far fa-users"
					   variant="outlined"
					   style="min-width: 0;"
					   [isDisabled]="loadingInProcess"
					   (action)="openUsersFilterPopup();">
					<span *ngIf="!activeSpecificUsers">All Users</span>
					<span *ngIf="activeSpecificUsers">
						{{activeSpecificUsers.length}} User{{activeSpecificUsers.length === 1 ? '' : 's'}} selected
					</span>
				</btn-c>
				<!-- active-filter dot -->
				<span *ngIf="activeSpecificUsers"
					  style="position: absolute; top: -4px; right: 2px; width: 10px; height: 10px; border-radius: 50%; background: #8be052; border: 2px solid #0d1117;">
				</span>
			</div>
		</div>

		<!-- Row 2 : legend + resource-type toggles -->
		<div class="flxRow align-items-center gap-0 animated fadeIn"
			 style="flex: 0 0 auto; margin-bottom: 14px; border-radius: 10px; overflow: hidden;
			        border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.03);">

			<!-- ── Legend section ─────────────────────────────────────── -->
			<div class="flxRow align-items-center gap-3"
				 style="padding: 10px 18px; border-right: 1px solid rgba(255,255,255,0.08); flex: 0 0 auto;">
				<span style="font-size: 11px; font-weight: 600; text-transform: uppercase;
				             letter-spacing: 0.6px; color: #4a5568; white-space: nowrap;">Legend</span>

				<!-- User chip (non-toggle, always shown) -->
				<div class="flxRow align-items-center gap-2"
					 style="padding: 5px 11px; border-radius: 20px;
					        background: rgba(46,204,113,0.12); border: 1.5px solid rgba(46,204,113,0.3);">
					<svg width="13" height="13" viewBox="0 0 13 13" style="flex-shrink: 0;">
						<circle cx="6.5" cy="6.5" r="5.5" fill="#2ecc71"/>
					</svg>
					<span style="font-size: 12px; font-weight: 600; color: #2ecc71; white-space: nowrap;">Users</span>
				</div>
			</div>

			<!-- ── Show / Hide toggles ────────────────────────────────── -->
			<div class="flxRow align-items-center gap-0"
				 style="padding: 6px 10px; flex: 1 1 auto;">
				<span style="font-size: 11px; font-weight: 600; text-transform: uppercase;
				             letter-spacing: 0.6px; color: #4a5568; white-space: nowrap; padding: 0 12px;">Show</span>

				<!-- Channels chip -->
				<div class="flxRow align-items-center gap-2"
					 style="cursor: pointer; padding: 4px 13px; margin: 3px 4px; border-radius: 0; transition: all 0.18s;
					        border: 1.5px solid;"
					 [style.border-color]="viewChannel ? 'rgba(77,138,240,0.5)' : 'rgba(255,255,255,0.1)'"
					 [style.background]="viewChannel ? 'rgba(77,138,240,0.15)' : 'rgba(255,255,255,0.03)'"
					 [style.opacity]="loadingInProcess ? '0.4' : '1'"
					 (click)="toggleResourceType('channel')">
					<svg width="13" height="13" viewBox="0 0 13 13" style="flex-shrink: 0;">
						<circle cx="6.5" cy="6.5" r="5.5" [attr.fill]="viewChannel ? '#4d8af0' : '#4a5568'"/>
					</svg>
					<span style="font-size: 12px; font-weight: 600; white-space: nowrap;"
						  [style.color]="viewChannel ? '#4d8af0' : '#5a6478'">Channels</span>
					<i class="far"
					   [class.fa-eye]="viewChannel"
					   [class.fa-eye-slash]="!viewChannel"
					   style="font-size: 10px;"
					   [style.color]="viewChannel ? '#4d8af0' : '#4a5568'"></i>
				</div>

				<!-- Drives chip -->
				<div class="flxRow align-items-center gap-2"
					 style="cursor: pointer; padding: 5px 13px; margin: 3px 4px; border-radius: 6px; transition: all 0.18s;
					        border: 1.5px solid;"
					 [style.border-color]="viewDrive ? 'rgba(232,168,56,0.5)' : 'rgba(255,255,255,0.1)'"
					 [style.background]="viewDrive ? 'rgba(232,168,56,0.15)' : 'rgba(255,255,255,0.03)'"
					 [style.opacity]="loadingInProcess ? '0.4' : '1'"
					 (click)="toggleResourceType('drive')">
					<svg width="13" height="13" viewBox="0 0 13 13" style="flex-shrink: 0;">
						<circle cx="6.5" cy="6.5" r="5.5" [attr.fill]="viewDrive ? '#e8a838' : '#4a5568'"/>
					</svg>
					<span style="font-size: 12px; font-weight: 600; white-space: nowrap;"
						  [style.color]="viewDrive ? '#e8a838' : '#5a6478'">Drives</span>
					<i class="far"
					   [class.fa-eye]="viewDrive"
					   [class.fa-eye-slash]="!viewDrive"
					   style="font-size: 10px;"
					   [style.color]="viewDrive ? '#e8a838' : '#4a5568'"></i>
				</div>

				<!-- Chats chip -->
				<div class="flxRow align-items-center gap-2"
					 style="cursor: pointer; padding: 5px 13px; margin: 3px 4px; border-radius: 20px; transition: all 0.18s;
					        border: 1.5px solid;"
					 [style.border-color]="viewChats ? 'rgba(224,82,82,0.5)' : 'rgba(255,255,255,0.1)'"
					 [style.background]="viewChats ? 'rgba(224,82,82,0.15)' : 'rgba(255,255,255,0.03)'"
					 [style.opacity]="loadingInProcess ? '0.4' : '1'"
					 (click)="toggleResourceType('chats')">
					<svg width="13" height="13" viewBox="0 0 13 13" style="flex-shrink: 0;">
						<circle cx="6.5" cy="6.5" r="5.5" [attr.fill]="viewChats ? '#e05252' : '#4a5568'"/>
					</svg>
					<span style="font-size: 12px; font-weight: 600; white-space: nowrap;"
						  [style.color]="viewChats ? '#e05252' : '#5a6478'">Chats</span>
					<i class="far"
					   [class.fa-eye]="viewChats"
					   [class.fa-eye-slash]="!viewChats"
					   style="font-size: 10px;"
					   [style.color]="viewChats ? '#e05252' : '#4a5568'"></i>
				</div>

				<!-- Meetings chip -->
				<div class="flxRow align-items-center gap-2"
					 style="cursor: pointer; padding: 5px 13px; margin: 3px 4px; border-radius: 20px; transition: all 0.18s;
					        border: 1.5px solid;"
					 [style.border-color]="viewMeeting ? 'rgba(155,89,182,0.5)' : 'rgba(255,255,255,0.1)'"
					 [style.background]="viewMeeting ? 'rgba(155,89,182,0.15)' : 'rgba(255,255,255,0.03)'"
					 [style.opacity]="loadingInProcess ? '0.4' : '1'"
					 (click)="toggleResourceType('meeting')">
					<svg width="13" height="13" viewBox="0 0 13 13" style="flex-shrink: 0;">
						<circle cx="6.5" cy="6.5" r="5.5" [attr.fill]="viewMeeting ? '#9b59b6' : '#4a5568'"/>
					</svg>
					<span style="font-size: 12px; font-weight: 600; white-space: nowrap;"
						  [style.color]="viewMeeting ? '#9b59b6' : '#5a6478'">Meetings</span>
					<i class="far"
					   [class.fa-eye]="viewMeeting"
					   [class.fa-eye-slash]="!viewMeeting"
					   style="font-size: 10px;"
					   [style.color]="viewMeeting ? '#9b59b6' : '#4a5568'"></i>
				</div>
			</div>
		</div>
	</div>

	<!-- GRAPH AREA (fills remaining height) -->
	<div class="flxClmn f-1-0 position-relative" style="min-height: 0;"
		 *ngIf="!loadingInProcess && resourceGraph?.graphData">

		<echarts-graph
			*ngIf="resourceGraph?.graphData && !_.isEmpty(resourceGraph.graphData)"
			class="flxClmn f-1-0"
			style="flex: 1 1 auto; min-height: 0;"
			[showLegend]="false"
			[nodeCfg]="graphNodeCfg"
			[nodeOptionsFn]="resourceGraph.nodeOptionsFn"
			[focusedNodesNames]="resourceGraph.nodeSearchResults"
			[rawGraphData]="resourceGraph.graphData">
		</echarts-graph>

		<span class="text-muted absolute-centralize animated fadeIn" style="font-size: 14px;"
			  *ngIf="!resourceGraph.graphData?.links?.length">
			No data for selected filters
		</span>
	</div>

</div>

<!-- Users filter popup -->
<popup-c class="bs-enabled"
		 *ngIf="usersPopup?.show"
		 head="Select Users for Mapping"
		 size="medium"
		 (closeCb)="usersPopup.show = false;"
		 (confirmCb)="usersPopup.apply()"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flxClmn gap-3 f-1-0" style="overflow: auto; min-height: 0;">
		<span>Select one or more users to get mapping information for:</span>

		<div class="flxClmn f-1-0 gap-2" style="overflow: auto; min-height: 0;">

			<label class="radio-container m-0" style="display: block;">
				All users
				<input type="radio"
					   [(ngModel)]="usersPopup.type"
					   [value]="usersFilterTypes.all">
				<span class="checkmark"></span>
			</label>

			<div class="flex-row gap-1 align-items-center">
				<label class="radio-container m-0" style="display: block; width: fit-content;">
					Specific users:
					<input type="radio"
						   [(ngModel)]="usersPopup.type"
						   [value]="usersFilterTypes.specific">
					<span class="checkmark"></span>
				</label>
			</div>

			<div class="position-relative f-1-0 flex-column overflow-auto" style="min-height: 0;">

				<!-- overlay when disabled -->
				<div class="w-100 h-100"
					 style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.4;"
					 *ngIf="usersPopup.type === usersFilterTypes.all">
				</div>

				<trustifi-table-c
					class="trustifi-table f-1-0"
					style="z-index: 5;"
					[list]="usersPopup.users"
					[cellsPrototype]="[{ textKey: 'email' }, { textKey: 'name' }]"
					(searchFunction)="usersPopup.searchUsers($event.searchTerm)"
					[options]="{
						itemsNameSingular: 'user',
						showRadioButtons: true,
						noHeader: true,
						showCounter: true
					  }">
				</trustifi-table-c>

			</div>
		</div>
	</div>
</popup-c>
